import lodash from 'lodash'
export default {
  getListPosition (state, payload) {
    state.positions = []
    payload.data.forEach(element => {
      state.positions.push(renderData(element))
    })
    state.total = payload.meta ? payload.meta.total : 0
    state.last_page = payload.meta ? payload.meta.last_page : 0
  },

  createPosition (state, payload) {
    state.positions.unshift(payload)
    state.total += 1
  },

  updatePosition (state, payload) {
    var index = lodash.findIndex(state.positions, ['id', payload.id])
    state.positions.splice(index, 1, payload)
  },

  destroyPosition (state, payload) {
    var index = lodash.findIndex(state.positions, ['id', payload.id])
    state.positions.splice(index, 1)
    state.total -= 1
  }
}

function renderData (item) {
  var data = {}
  data.id = item.id
  data.name = item.name
  data.status = item.status
  data.order = item.order
  return data
}



// WEBPACK FOOTER //
// ./src/store/module/position/mutations.js